import { render, staticRenderFns } from "./SourceOfWealthCN.vue?vue&type=template&id=2afb9e58"
import script from "./SourceOfWealthCN.vue?vue&type=script&lang=js"
export * from "./SourceOfWealthCN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports